import { createRoot } from "react-dom/client";
import I18n from "i18n-js";
import "@app/style/main.css";
import { scheduleInitialSplashRemoval } from "@common/helpers/splash";
import { setLanguage } from "@common/helpers/i18n";
import enLocale from "./assets/locale/en-US.json";
import faLocale from "./assets/locale/fa-IR.json";
import App from "./App";
import { getInitialAppLocale } from "./helpers/publicLocale";
import Main from "./layout/Main";
import * as routes from "./routes";

const initialLocale = getInitialAppLocale();
const initialTranslations =
  initialLocale === "en-US" ? enLocale : faLocale;

I18n.translations = {
  ...I18n.translations,
  [initialLocale]: {
    ...(I18n.translations[initialLocale] || {}),
    ...initialTranslations,
    [import.meta.env.VITE_SITE_NAME]: import.meta.env.VITE_SITE_TITLE,
  },
};
I18n.locale = initialLocale;
setLanguage(initialLocale);

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(<App routes={routes} layout={Main} />);
scheduleInitialSplashRemoval();
